import { SolComponentEntry } from '../../../services/dialog.service';

export class SolDialogContainerState {
  private constructor(public readonly entry: SolComponentEntry | undefined) {}

  public static of(): SolDialogContainerState {
    return new SolDialogContainerState(undefined);
  }

  public withEntry(entry: SolComponentEntry | undefined): SolDialogContainerState {
    if (entry === this.entry) {
      return this;
    }
    return new SolDialogContainerState(entry);
  }
}
